import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { api, messageOf } from "../api.js";
import { setMe } from "../auth.js";
import { AuthCard, ErrorText } from "../components/ui.jsx";

/** メールの「登録を完了する」の先。トークンを確かめて、そのままホームへ（もう一度ログインさせない） */
export function VerifyPage() {
  const [sp] = useSearchParams();
  const token = sp.get("token") ?? "";
  const nav = useNavigate();
  const qc = useQueryClient();
  const [err, setErr] = useState<string | undefined>();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const me = await api("POST", "/auth/verify-email", { token });
        await setMe(qc, me);
        nav("/home", { replace: true, state: { justRegistered: true } });
      } catch (e) {
        setErr(messageOf(e));
      }
    })();
  }, [token, nav, qc]);

  return (
    <AuthCard title="登録を完了しています">
      {err ? (
        <>
          <ErrorText>{err}</ErrorText>
          <div className="authlinks">
            <Link className="btn text" to="/signup">会員登録画面へ（確認メールを再送できます）</Link>
            <Link className="btn text" to="/login">ログイン</Link>
          </div>
        </>
      ) : (
        <p className="hint">少しお待ちください…</p>
      )}
    </AuthCard>
  );
}
